module.exports = __webpack_public_path__ + "Samsung_S8_S9.svg?f86072d8171a9be1a6ed4dfa0feef6eb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Samsung_S8_S9.svg
// module id = 211
// module chunks = 0